import { computed, Injectable, OnDestroy, signal } from '@angular/core';

const MOBILE_BREAKPOINT = 768;
const TABLET_BREAKPOINT = 1200;

@Injectable({ providedIn: 'root' })
export class IsMobileService implements OnDestroy {
  private resizeObserver: ResizeObserver;
  private contentWidth = signal<number | undefined>(undefined);

  public isMobile = computed(() => this.media() === 'mobile');
  public isTablet = computed(() => this.media() === 'tablet');
  public isDesktop = computed(() => this.media() === 'desktop');

  private media = computed<'mobile' | 'tablet' | 'desktop'>(() => {
    const width = this.contentWidth();

    if (width === undefined) {
      return undefined;
    }

    if (width < MOBILE_BREAKPOINT) {
      return 'mobile';
    } else if (width < TABLET_BREAKPOINT) {
      return 'tablet';
    } else {
      return 'desktop';
    }
  });

  constructor() {
    this.resizeObserver = new ResizeObserver((entries) => {
      this.contentWidth.set(entries[0].contentRect.width);
    });

    this.resizeObserver.observe(document.body);
  }

  public ngOnDestroy() {
    this.resizeObserver.disconnect();
  }
}
